module.exports = __webpack_public_path__ + "static/media/NotOpen.91d3e241.svg";